/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ProfileJobItemLastContactChannel = typeof ProfileJobItemLastContactChannel[keyof typeof ProfileJobItemLastContactChannel] | null;


export const ProfileJobItemLastContactChannel = {
  email: 'email',
  linkedin: 'linkedin',
  task: 'task',
} as const;
